import axios from 'axios'

axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头

// 添加一个响应拦截器
axios.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    //FIXME 返回首页或者啥的
    return Promise.reject(error);
});

import userApi from '@/components/api/userApi.js'
import unitApi from '@/components/api/unitApi.js'
import menuApi from '@/components/api/menuApi.js'
import enumApi from '@/components/api/enumApi.js'
import eventApi from '@/components/api/eventApi.js'
import videoApi from '@/components/api/videoApi.js'
import archivesApi from '@/components/api/archivesApi.js'
import entityApi from '@/components/api/entityApi.js'
import powerApi from '@/components/api/powerApi.js'
import realApi from '@/components/api/realApi.js'
import deviceApi from '@/components/api/deviceApi.js'
import historyApi from '@/components/api/historyApi.js'
import variableApi from '@/components/api/variableApi.js'
import generallyRiseApi from '@/components/api/generallyRiseApi.js'
import svgApi from '@/components/api/svgApi.js'
import roleApi from '@/components/api/roleApi.js'
import systemApi from '@/components/api/systemApi.js'
import reportApi from '@/components/api/reportApi.js'
import debugApi from '@/components/api/debugApi.js'
import cameraApi from '@/components/api/camera/cameraApi.js'
import webSocketApi from '@/components/api/webSocketApi.js'
import resourcesApi from '@/components/api/resourcesApi.js'
//钱财相关接口
import balanceApi from '@/components/api/money/balanceApi.js'
//工单api
import flowApi from '@/components/api/order/flowApi.js'
import orderGroupApi from '@/components/api/order/orderGroupApi.js'
//西门子专用api
import siemensApi from '@/components/api/siemens/siemensApi.js'
//华普专用api
import huapuApi from '@/components/api/huapuApi.js'
//变电站 轮询
import transformerProtectApi from '@/components/api/transformerProtectApi.js'
//工单
import orderApi from '@/components/api/order/orderApi.js'
import messageApi from '@/components/api/order/messageApi.js'
//需量接口
import demandApi from '@/components/api/demandApi.js'
//充电桩API
import recordApi from '@/components/api/money/recordApi.js'
//数据检查api
import historyCheckApi from '@/components/api/database/historyCheckApi.js'
//班组管理api
import teamAssessmentApi from '@/components/api/teamAssessment/teamAssessmentApi.js'
//通道监测
import channelApi from '@/components/api/channelApi.js'
//海康威视专用api
import hikvisonApi from '@/components/api/camera/hikvisonApi.js'
//西瑞接入的曼顿平台接口
import mandunApi from '@/components/api/mandun/mandunApi.js'
//宁波港
import ningboApi from '@/components/api/projectDingZhi/ningbo/workorderApi.js'
//天澄分摊
import tcFentanApi from '@/components/api/projectDingZhi/tiancheng/fentanApi.js'
//app专用接口
import appApi from '@/components/api/appApi.js'
//灯控接口
import lightApi from '@/components/api/light/lightApi.js'
import lightOldApi from '@/components/api/light/lightOldApi.js'
import controlApi from '@/components/api/controlApi.js'
//后台监控
import actuatorApi from '@/components/api/actuatorApi.js'
//操作树
import queueGroupApi from '@/components/api/queueGroupApi.js'
//用户设备关联关系
import userRelDevice from '@/components/api/userRelDevice.js'
//抄表接口
import meterReadingApi from '@/components/api/meterReading/meterReadingApi.js'
//监测点管理
import monitoringPointApi from '@/components/api/monitoringPointApi.js'
//公告管理
import noticeApi from '@/components/api/noticeApi.js'
//支付
import payApi from '@/components/api/money/payApi.js'
//橘子物联
import orangeWulianApi from '@/components/api/orangewulian/orangeWulianApi.js'
//水务
import waterAffairsApi from '@/components/api/waterAffairs/waterAffairsApi.js'
//采集端的设备定时遥控指令
import timeRemoteControlApi from '@/components/api/timeRemoteControl/timeRemoteControlApi.js'
//维度iot平台接口
import iotApi from '@/components/api/iot/iotApi.js'
//天气接口
import weatherApi from '@/components/api/weatherApi.js'
//采集配置
import deviceCollectionConfigApi from '@/components/api/deviceCollectionConfigApi.js'
//线缆
import cableApi from '@/components/api/cableApi.js'
// 消缺管理
import workDefectApi from '@/components/api/order/workDefectApi.js'
//能流图
import energyFlowApi from '@/components/api/energyFlowApi.js'
//电梯监控elevatorMonitoring
import elevatorMonitoringApi from '@/components/api/elevatorMonitoringApi.js'
//预付费接口
import prepaymentApi from '@/components/api/prepaId/prepaymentApi.js'
//测试接口
import testApi from '@/components/api/testApi.js'
//区域能耗接口
import areausePower from '@/components/api/areausePower.js'
//手工填报
import manualApi from '@/components/api/manualApi.js'
//虚拟电厂
import plantApi from '@/components/api/virtualPowerPlant.js'
// 人工填报
import manualInputVariableApi from '@/components/api/manualInputVariableApi'
// 生产制造看板人工填报
import manufacturingKanbanApi from '@/components/api/manufacturingKanbanApi';

export default {
    install(Vue) {
        Vue.prototype.$api = {
            //通用方法
            POST: (url, params) => {
                return axios.post(`${url}`, params).then(res => res.data)
            },
            GET: (url, params) => {
                return axios.get(`${url}`, {
                    params: params
                }).then(res => res.data)
            },
            PUT: (url, params) => {
                return axios.put(`${url}`, params).then(res => res.data)
            },
            DELETE: (url, params) => {
                return axios.delete(`${url}`, {
                    params: params
                }).then(res => res.data)
            },
            PATCH: (url, params) => {
                return axios.patch(`${url}`, params).then(res => res.data)
            },
            JSONP: (url, params) => {
                return axios.jsonp(`${url}`, params).then(res => res.data)
            },
            toJson: obj => {
                return JSON.stringify(obj);
            },
            toObject: jsonStr => {
                return eval('(' + jsonStr + ')');
            },
            userApi,
            unitApi,
            menuApi,
            enumApi,
            eventApi,
            videoApi,
            archivesApi,
            entityApi,
            powerApi,
            realApi,
            deviceApi,
            historyApi,
            variableApi,
            generallyRiseApi,
            svgApi,
            roleApi,
            systemApi,
            reportApi,
            debugApi,
            siemensApi,
            huapuApi,
            flowApi,
            cameraApi,
            webSocketApi,
            resourcesApi,
            orderApi,
            orderGroupApi,
            transformerProtectApi,
            demandApi,
            recordApi,
            historyCheckApi,
            teamAssessmentApi,
            messageApi,
            //钱相关
            balanceApi,
            channelApi,
            hikvisonApi,
            mandunApi,
            ningboApi,
            tcFentanApi,
            appApi,
            lightApi,
            lightOldApi,
            controlApi,
            actuatorApi,
            queueGroupApi,
            userRelDevice,
            meterReadingApi,
            monitoringPointApi,
            noticeApi,
            payApi,
            orangeWulianApi,
            waterAffairsApi,
            timeRemoteControlApi,
            iotApi,
            weatherApi,
            deviceCollectionConfigApi,
            cableApi,
            workDefectApi,
            energyFlowApi,
            elevatorMonitoringApi,
            prepaymentApi,
            testApi,
            areausePower,
            manualApi,
            plantApi,
            manualInputVariableApi,
            manufacturingKanbanApi
        }
    }
}